exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".houseInteriorRoom{height:545px}.houseInteriorRoom .backgroundImage{position:absolute;left:0;top:0;width:800px;height:575px;max-width:100%}.houseInteriorRoom .owlsInside{position:absolute;bottom:0}.houseInteriorRoom .owlTwo{right:30%}.houseInteriorRoom .owlOne{right:40%}.houseInteriorRoom .owlOneSide{left:30%}.houseInteriorRoom .OwlShopPatcher .categorySelector a.selector{width:90px}.houseInteriorRoom .shopHeader{position:absolute;z-index:9000}.houseInteriorRoom .shopHeader .shopLogo{cursor:pointer;height:46px;padding:5px;background:#fff;border-radius:5px;box-shadow:0 3px 12px #bbb}.houseInteriorRoom .patcher{position:absolute;width:80%;top:5%;left:10%;z-index:10}.houseInteriorRoom .right_close{float:right;cursor:pointer}.houseInteriorRoom .spinnerBox{z-index:9000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/house_interior_room.scss
// module id = 1325
// module chunks = 0